import { Component, EventEmitter, Input, Output,ChangeDetectorRef, OnInit } from '@angular/core';
import { ActionSheetController, AlertController, ModalController } from '@ionic/angular';
import { FileObj } from '../../../../model/FileObj';
import { NativeService } from '../../../providers/NativeService';
import {PreviewPictureComponent} from '../preview-picture/preview-picture.component';
import { DataService,LocalStorageService,AppService} from '../../../service';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { Observable } from 'rxjs';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { Device } from "@ionic-native/device/ngx";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'select-picture',
  templateUrl: './select-picture.component.html',
  styleUrls: ['./select-picture.component.scss']

})
export class SelectPictureComponent implements OnInit {
  @Input() max = 6; // 最多可选择多少张图片，默认为4张

  @Input() allowAdd = true; // 是否允许新增

  @Input() allowDelete = true; // 是否允许删除
  @Input() isAttachment = false; // 是否为'添加附件'

  @Input() fileObjList: FileObj[] = []; // 图片列表,与fileObjListChange形成双向数据绑定
  @Input() fileIds = "";
  @Output() fileObjListChange = new EventEmitter<any>();
  constructor(private modalCtrl: ModalController,
              private alertController: AlertController,
              private actionSheetCtrl: ActionSheetController,
              private changeDetectorRef: ChangeDetectorRef,
              private dataService: DataService,              
              private appService: AppService,
              private fileTransfer: FileTransfer,
              private localStorageService: LocalStorageService,
              private diagnostic: Diagnostic,
              private device: Device,
              // private fileService: FileService,
              // private globalData: GlobalData
              private nativeService: NativeService,
              private translateService: TranslateService,) {

  }
  ngOnInit(){
    let that =this;
    console.log("OnInit====");
    if(that.fileIds&&that.fileObjList.length<1){
      let tmpFileId = that.fileIds.split(",");
      tmpFileId.forEach(item => {
        that.dataService.getFile(item).subscribe(res=>{
          let tmpFile ={
            id: res.DATA.id,
            path: res.DATA.remoteFullPath,
          }
          that.fileObjList.push(tmpFile);
          console.log(that.fileObjList);
          console.log("that.fileObjList====");
          that.changeDetectorRef.detectChanges();
        })
      });
    }
  }
  addPicture() {// 新增照片
    let base64='data:image/png;base64,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';
    const that = this;
    that.actionSheetCtrl.create({
      buttons: [
        {
          text: this.translateService.instant('aramark_choose_from_media_msg'),
          handler: () => {
            if(this.device.platform=="Android"){
              console.log("Android");
              that.nativeService.getMultiplePicture({// 从相册多选
                maximumImagesCount: (that.max - that.fileObjList.length),
                destinationType: 1 // 期望返回的图片格式,1图片路径
              }).subscribe(imgs => {
                for (const img of imgs as string[]) {
                  that.getPictureSuccess(img);
                }
              });
            }else{
              this.diagnostic.getCameraRollAuthorizationStatus().then((status)=>{
                console.log("statusNOT_REQUESTED");
                console.log(status);
  
                if(status=="not_determined"){
                  this.diagnostic.requestCameraRollAuthorization().then(()=>{
                    that.diagnostic.isCameraRollAuthorized().then( (auth)=>{
                      if(auth!=true){
                        this.openPhotoLib();
                      }else{
                        that.nativeService.getMultiplePicture({// 从相册多选
                          maximumImagesCount: (that.max - that.fileObjList.length),
                          destinationType: 1 // 期望返回的图片格式,1图片路径
                        }).subscribe(imgs => {
                          for (const img of imgs as string[]) {
                            that.getPictureSuccess(img);
                          }
                        });
                      }
                    }
                    ).catch(err => {
                      this.appService.toastTip(this.translateService.instant('aramark_get_image_fail'),false);
                      }      
                    );
                  })
                }else{
                  that.diagnostic.isCameraRollAuthorized().then( (auth)=>{
                    if(auth!=true){
                      this.openPhotoLib();
                    }else{
                      that.nativeService.getMultiplePicture({// 从相册多选
                        maximumImagesCount: (that.max - that.fileObjList.length),
                        destinationType: 1 // 期望返回的图片格式,1图片路径
                      }).subscribe(imgs => {
                        for (const img of imgs as string[]) {
                          that.getPictureSuccess(img);
                        }
                      });
                    }
                  }
                  ).catch(err => {
                    this.appService.toastTip(this.translateService.instant('aramark_get_image_fail'),false);
                    }      
                  );
                }
              });
            }

            // that.diagnostic.isCameraRollAuthorized().then( (auth)=>{
            //   if(auth!=true){
            //     this.openPhotoLib();
            //   }else{
            //     that.nativeService.getMultiplePicture({// 从相册多选
            //       maximumImagesCount: (that.max - that.fileObjList.length),
            //       destinationType: 1 // 期望返回的图片格式,1图片路径
            //     }).subscribe(imgs => {
            //       for (const img of imgs as string[]) {
            //         that.getPictureSuccess(img);
            //       }
            //     });
            //   }
            // }
            // ).catch(err => {
            //   this.appService.toastTip(this.translateService.instant('aramark_get_image_fail'),false);
            //   }      
            // );
            // that.getPictureSuccess({"filePath":"/Users/xxs/Downloads/13857447608.png","base64":base64});
          }
        },
        {
          text: this.translateService.instant('aramark_choose_take_photo_msg'),
          handler: () => {
            this.diagnostic.getCameraAuthorizationStatus().then((status)=>{
              console.log(status)
              console.log("status====")
              if(status==true){
                that.diagnostic.isCameraAuthorized().then( (auth)=>{
                  if(auth!=true){
                    this.openCamera();
                  }else{
                    that.nativeService.getPicture().subscribe(img => {
                      // console.log(img);
                      that.getPictureSuccess(img);
                    });
                  }
                }).catch(err => {
                  this.appService.toastTip(this.translateService.instant('aramark_get_image_fail'),false);
                  }      
                );
              }else{
                this.diagnostic.requestCameraAuthorization().then(
                  (auth)=>{
                    if(auth){
                      that.nativeService.getPicture().subscribe(img => {
                        // console.log(img);
                        that.getPictureSuccess(img);
                      });                    }
                  }
                );
              }
            });
         
          }
        },
        {
          text: this.translateService.instant('aramark_cancel'),
          role: 'cancel'
        }
      ]
    }).then(res=>{
      res.present();
    })
  }
  async openCamera() {
    const confirm = await this.alertController.create({
      header: '提示',
      message: '请打开相机权限',
      buttons: [
        {
          text: '否',
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: '是',
          handler: () => {
            this.diagnostic.switchToSettings();
          }
        }
      ]
    });
    await confirm.present();
  }
  async openPhotoLib() {
    const confirm = await this.alertController.create({
      header: '提示',
      message: '请打开相册权限',
      buttons: [
        {
          text: '否',
          handler: () => {
            // console.log('Disagree clicked');
          }
        },
        {
          text: '是',
          handler: () => {
            this.diagnostic.switchToSettings();
          }
        }
      ]
    });
    await confirm.present();
  }

  deletePicture(i) {// 删除照片
    if (!this.allowDelete) {
      return;
    }
    this.alertController.create({
      header: this.translateService.instant('aramark_confirm_delete_msg'),
      buttons: [{text: this.translateService.instant('aramark_cancel')},
      {
        text: this.translateService.instant('aramark_confirm'),
        handler: () => {
            const delArr = this.fileObjList.splice(i, 1);
            console.log(delArr);
            console.log("delArr====");
            const delId = delArr[0].id;
            if (delId) {
              this.dataService.deleteFile(delId);
              console.log("delArr===="+delId);
              // this.globalData.showLoading = false;
              // this.fileService.deleteById(delId);
              let tmpIds =[];
              this.fileObjList.forEach(item => {
                tmpIds.push(item.id);
              });
              this.fileIds  = tmpIds.join(",");
              console.log("deletePicture");
              console.log(this.fileIds);
              this.changeDetectorRef.detectChanges();
            }
          }
      }
      ]
    }).then(res=>{
        res.present();
    })
  }

  viewerPicture(index) { // 照片预览
    const picturePaths = [];
    for (const fileObj of this.fileObjList) {
      if(fileObj.base64){
        picturePaths.push(fileObj.base64);
      }else if(fileObj.path){
        picturePaths.push(fileObj.path);
      }else{
        picturePaths.push(fileObj.origPath);
      }
    }

    this.modalCtrl.create({
      component: PreviewPictureComponent,
      componentProps: {
        'initialSlide': index,
        'picturePaths': picturePaths
      },
      showBackdrop: true,
      backdropDismiss: true,
      cssClass: ['preview-picture']
    }).then(res=>{
      res.present();
    });
    // this.modalCtrl.create(
    // component:  "PreviewPicturePage", 
    // {'initialSlide': index, 'picturePaths': picturePaths}
    // ).present();
  }

  private getPictureSuccess(img) {
    let that =this;
    let fileObj: FileObj = {};
    fileObj.origPath = img.filePath;
    fileObj.base64 = img.base64;
    // that.fileObjList.push(fileObj);
    let filePath = fileObj.origPath;
    console.log("getPictureSuccess BBBBBB");
    let transfer: FileTransferObject = this.fileTransfer.create();
    let options: FileUploadOptions = {
      httpMethod:"POST",
      fileKey: 'file',
      fileName: filePath.substr(filePath.lastIndexOf('/') + 1),
      mimeType: "image/jpeg",
      headers: {
        'Content-Disposition':'form-data', 
        'Token': this.localStorageService.getStore("token")}
    }
    let urlPrefix = this.dataService.urlPrefix;
    transfer.upload(filePath, urlPrefix+"/file", options)
    .then(data => {
      console.log("getPictureSuccess AAAAAA");
        if(data.responseCode==200){
        let res = JSON.parse(data.response);
        console.log(res);
        fileObj.id = res.DATA.id;
        fileObj.path = res.DATA.remoteFullPath;
        that.fileObjList.push(fileObj);
        let tmpIds =[];
        that.fileObjList.forEach(item => {
          tmpIds.push(item.id);
        });
        this.fileIds  = tmpIds.join(",");
        that.fileObjListChange.emit(that.fileObjList);
        this.changeDetectorRef.detectChanges();
      }
    }, (err) => {
      console.log("getPictureSuccess  errr");
      console.log(err);
    });

    // that.nativeService.upload(fileObj.origPath).subscribe(res=>{
    //   console.log(res);
    //   console.log("getPictureSuccess AAAA");
    //   if(res.STATUS=="0"){
    //     console.log(that.fileObjList.length);
    //     console.log("getPictureSuccess res");
    //     console.log(res);
    //     fileObj.id = res.DATA.id;
    //     fileObj.path = res.DATA.remoteFullPath;
    //     that.fileObjList.push(fileObj);
    //     that.fileObjListChange.emit(that.fileObjList);
    //     this.changeDetectorRef.detectChanges();
    //   }
    // },err=>{
    //   console.log("getPictureSuccess  errr");
    //   console.log(err);
    // })
  }

}
